import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { ZipcodeService } from '../zipcode.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-zipcode-list',
  templateUrl: './zipcode-list.component.html',
  styleUrls: ['./zipcode-list.component.scss']
})
export class ZipcodeListComponent implements OnInit {

  constructor(private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private zipcodeService: ZipcodeService) { }

  // ViewChild
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];
  pageSize = 10;
  fileToUpload: File | null = null;
  saving: boolean = false;
  userLogin: UserLogin;
  neigbhoodCode: string = '';
  stateCode: string = '';


  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Código postal',
      field: 'IdZipCode',
      width: 10,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Colonia',
      field: 'NeighborhoodCode',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      cellRenderer: (params: any) => (params.data.NeighborhoodCode + ' - ' + params.data.NeighborhoodName)
    },
    {
      headerName: 'Ciudad',
      field: 'CityCode',
      width: 20,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false,
      cellRenderer: (params: any) => (params.data.CityCode + ' - ' + params.data.CityDescription)
    },
    {
      headerName: 'Estado',
      field: 'StateCode',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      cellRenderer: (params: any) => (params.data.StateCode + ' - ' + params.data.StateDescription)
    },
    {
      headerName: 'Localidad',
      field: 'StateCode',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      cellRenderer: (params: any) => (params.data.LocationCode + ' - ' + params.data.LocationDescription)
    }
  ];

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getFiscalConfig();
  }

  onPageSizeChange(value: number) {
    this.pageSize = value;
    this.getFiscalConfig();
  }

  btnAddClick() {
    this.router.navigate(['/tax/zipcode/create']);
  }

  edit(row: any) {
    this.router.navigate(['/tax/zipcode', row.data.IdZipCode]);
  }

  async delete(row: any) {
	  const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar el código postal " + row.data.IdZipCode + "?", 'question1', 'Confirmacion');
    
    if (result) {
      this.zipcodeService.deleteZipCode(row.data.Org, row.data.IdZipCode).subscribe(async data => {
        console.log("result", data);
        await this.globalFunctionService.messageBimbo('La Código postal se eliminó correctamente.', 'success', '¡Éxito!');
      }, async (error) => {
        console.log("error", error);
        await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
      }, () => {
        this.getFiscalConfig();
      });
    }
  }


  getFiscalConfig() {
    // this.zipcodeService.getZipCodeList().subscribe(data => {
    //   this.ceqGrid.data = data;
    // });

    var url: string = `zipcode/${this.userLogin.Org}/list/${this.pageSize}`;
    if(this.stateCode != ''){
      url += `?stateCode=${this.stateCode}`
    }
    if(this.neigbhoodCode != ''){
      url += this.stateCode != '' ? `&neighborhoodCode=${this.neigbhoodCode}` : `?neighborhoodCode=${this.neigbhoodCode}`
    }
    this.ceqGrid.endPoint = url;
    this.ceqGrid.refreshTable();
  }

  async handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);

    if (this.fileToUpload != null) {
      if (this.fileToUpload.name.endsWith(".csv")) {
        this.uploadFileToActivity();
      }
      else {
		    await this.globalFunctionService.messageBimbo('El archivo seleccionado debe tener formato .csv ', 'warning', '¡Cuidado!');
        this.fileToUpload = null;
      }
    }
    console.log(this.fileToUpload);

  }

  uploadFileToActivity() {
    const formData: FormData = new FormData();
    formData.append('zipCodes', this.fileToUpload, this.fileToUpload.name);
    this.saving = true;
    this.zipcodeService.importZipCodes(formData)
      .toPromise()
      .then(async x => {
		    await this.globalFunctionService.messageBimbo('Se ha guardado la información: ', 'success', '¡Éxito!');
        this.saving = false;
        this.fileToUpload = null;
      })
      .catch(async (e) => {
		    await this.globalFunctionService.messageBimbo('Ha ocurrido un error al guardar', 'error', '¡Error!');
        this.saving = false;
        this.fileToUpload = null;
      });
  }


}
